import classNames from 'classnames'
import moment from 'moment'
import { forwardRef, ReactNode } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { FieldError } from 'react-hook-form'

type InputProps = {
  id: string
  name: string
  className: string
  containerClassName?: string
  placeholder: string
  label: string
  showLabel?: boolean
  errors?: FieldError
  disabled?: boolean
  value: string
  minDate?: Date
  maxDate?: Date
  onChange: (value: string) => void
  offset?: 'endOfDay' | 'startOfDay' | null
  children?: ReactNode
}

const CustomDateTimeInput = forwardRef<any>((props: any, ref) => (
  <button type='button' className={classNames(props.className, 'w-full sm:w-auto')} onClick={props.onClick} ref={ref}>
    {props.value}
  </button>
))

export const ControlledDatepickerInputSM = (props: InputProps) => {
  const {
    id,
    name,
    className,
    containerClassName = '',
    placeholder,
    label,
    showLabel = false,
    errors,
    disabled,
    value,
    onChange,
    minDate,
    maxDate,
    offset,
    children
  } = props

  return (
    <div className={classNames('mb-2', containerClassName)}>
      <label className={classNames('block pl-2 pb-2 text-sm text-text font-bold', { 'sr-only': !showLabel })} htmlFor={id}>
        {label}
      </label>
      <div className='relative'>
        <DatePicker
          portalId={id}
          className={classNames(className, disabled && 'text-text/50 !bg-text/5 !cursor-not-allowed')}
          id={id}
          name={name}
          calendarClassName='!relative'
          placeholderText={placeholder}
          selected={new Date(value)}
          minDate={minDate}
          maxDate={maxDate}
          dateFormat='dd/MM/yyyy'
          onChange={(date) => {
            if (offset === 'startOfDay') {
              onChange(moment(date?.toISOString()).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toISOString())
            } else if (offset === 'endOfDay') {
              onChange(moment(date?.toISOString()).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).toISOString())
            } else {
              onChange(moment(date).toISOString())
            }
          }}
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode='select'
          closeOnScroll
          disabledKeyboardNavigation
          customInput={<CustomDateTimeInput />}
          disabled={disabled}
        />
      </div>
      <p className='pl-2 pt-2 text-error text-xs'>{errors?.message}</p>
    </div>
  )
}
